package hk.com.vr360_demo2.webapp.core.ui_state

sealed class ProgressBarState {

    data object ButtonLoading : ProgressBarState()

//    data object ScreenLoading : ProgressBarState()

    data object FullScreenLoading : ProgressBarState()



    data class MessageLoading(val message: String) : ProgressBarState()
    //攜帶數據的loading
    data class DataLoading<T>(val data: T? = null) : ProgressBarState()

    data object Idle : ProgressBarState()

}

